import React from "react"
import EmployeeTraining from "./EmployeeTraining"
import EmployeeWorkHistory from "./EmployeeWorkHistory"
import EmployeeUsualWork from "./EmployeeUsualWork"
import EmployeeBans from "./EmployeeBans"
import { Divider } from "antd"
import useSchedulesQueryParams from "hooks/useSchedulesQueryParams"
import { useEmployeeScheduleDefaults } from "hooks/useScheduleDefaults"

const Location: React.FC = () => {
	useEmployeeScheduleDefaults()
	const { selectedEmployee = "" } = useSchedulesQueryParams()

	return (
		<div>
			<EmployeeWorkHistory selected={selectedEmployee} />
			<Divider />
			<EmployeeBans selected={selectedEmployee} />
			<Divider />
			<div className="grid grid-cols-2 divide-x-0.5 py-5">
				<EmployeeTraining selected={selectedEmployee} />
				<EmployeeUsualWork selected={selectedEmployee} />
			</div>
		</div>
	)
}

export default Location
